import { z } from 'zod'

export const ContactFormSchema = z.object({
  budget: z.string().optional(),
  email: z.string().email('Invalid email address'),
  message: z.string().optional(),
  name: z.string().min(2, 'Must be at least 2 characters'),
  phone: z.string().min(7, 'Must be at least 7 characters').optional(),
  project: z.string().optional(),
})

export type ContactFormSchemaType = z.infer<typeof ContactFormSchema>
